import {
  FilterDisclosure,
  FilterFooter,
  FilterListbox,
  FilterOptionCheckbox,
  FilterPopover,
} from '@vtex/admin-ui'
import { useSalesChannels } from 'hooks'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import type { SimplifiedPromotion } from 'typings'
import { usePromotionsFilterMultipleState } from '../useFiltersState'

function filterBySalesChannel(
  promotion: SimplifiedPromotion,
  salesChannels: string[] | undefined
) {
  if (!salesChannels || !salesChannels.length) return true

  if (!promotion.salesChannels.ids.length) return true

  return (
    promotion.salesChannels.exclusive !==
    promotion.salesChannels.ids.some((sc) => salesChannels.includes(sc))
  )
}

export function FilterBySalesChannel() {
  const { formatMessage } = useIntl()

  const state = usePromotionsFilterMultipleState({
    id: 'salesChannel',
    filterFn: (item) =>
      filterBySalesChannel(
        item,
        state.appliedItems.map((x) => x.id)
      ),
  })

  const {
    data: salesChannels,
    isLoading,
    isSuccess,
    isError,
  } = useSalesChannels()

  useEffect(() => {
    if (isError) {
      state.setStatus('error')
    }
  }, [isError, state])

  useEffect(() => {
    isLoading && state.setStatus('loading')
    isSuccess && state.setStatus('ready')
  }, [isLoading, isSuccess])

  const options =
    salesChannels?.map((sc) => ({ id: sc.id, label: sc.name })) ?? []

  return (
    <>
      <FilterDisclosure state={state}>
        {formatMessage({ id: 'admin/promotions.filters.sales-channel' })}
      </FilterDisclosure>
      <FilterPopover state={state}>
        <FilterListbox>
          {options.map((item) => (
            <FilterOptionCheckbox key={item.id} {...item} value={item.id} />
          ))}
        </FilterListbox>
        <FilterFooter />
      </FilterPopover>
    </>
  )
}
